$(function () {
	const carousel = ".owl-carousel.image-slider"

	const carouselOptions = {
		loop: $(carousel).data("nav"),
		dots: $(carousel).data("dots"),
		autoplay: $(carousel).data("autoplay"),
		navText: ["<span aria-label='Previous slide'><i class='fas fa-arrow-left'></i></span>", "<span aria-label='Next slide'><i class='fas fa-arrow-right'></i></span>"],
		responsive: {
			0: {
				items: 1,
			},
			991: {
				nav: $(carousel).data("nav"),
				items: 3,
				margin: 100,
				center: true,
				autoWidth: true,
				stagePadding: 200,
			},
		},
		onInitialized: function (event) {
			const target = event.target.id ? event.target.id : event.target.classList[1]
			console.log(`${target} has been initialized.`)
		},
	}

	if ($(carousel).length > 0) {
		$(carousel).owlCarousel(carouselOptions)
	}

	Shopify.designMode &&
		document.addEventListener("shopify:section:load", (event) => {
			if ($(event.target).hasClass("image-slider")) {
				console.log("Image Slider Carousel has been reload!")

				$(carousel).trigger("destroy.owl.carousel")
				$(carousel).owlCarousel(carouselOptions)
			}
		})
})
